import React from 'react';

const variants = {
  primary:
    'tw-bg-primary-50 tw-text-primary-700 tw-border tw-border-primary-200',
  accent:
    'tw-bg-accent-50 tw-text-accent-700 tw-border tw-border-accent-200',
  gray:
    'tw-bg-gray-100 tw-text-gray-700 tw-border tw-border-gray-200',
  warning:
    'tw-bg-yellow-50 tw-text-yellow-700 tw-border tw-border-yellow-200',
};

const Badge = ({
  children,
  variant = 'primary',
  className = '',
}) => {
  return (
    <span
      className={`tw-inline-flex tw-items-center tw-px-2.5 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium ${variants[variant] || variants.primary} ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
